import ProductTemplate from  '../Common/ProductTemplate/ProductTemplate';

export const issuuList = ProductTemplate.data;


// WEBPACK FOOTER //
// ./src/IssuuPreview/PreviewData.js